import amplitude from 'tools/amplitude/amplitude';

import type {
  LogDefectAlertParams,
  LogDialogParams,
  LogEventDefectAlert,
} from './mozart.analytic.model';

const ANALYTIC_EVENT_NAME = 'DEFECT_ALERT';

export function logAnalyticMozartDefectAlert(params: LogDefectAlertParams) {
  const {
    complaint,
    action,
    turnOffTime,
    solutionType,
    solutionOpenBox,
  } = params;
  const data: LogEventDefectAlert = {
    PARTNER_ID: complaint.partnerId,
    STORE_ID: complaint.storeId,
    ALERT_ID: complaint.alertId,
    DEFECT_TYPE_ALERT: complaint.reason,
    ACTION: action,
  };
  const isActionTurnOff = action === 'turn_off_product';
  if (isActionTurnOff) data.TURN_OFF_TIME = turnOffTime;
  if (!isActionTurnOff) data.SOLUTION_TYPE = solutionType;
  if (solutionType === 'other') data.SOLUTION_OPEN_BOX = solutionOpenBox;
  amplitude.logEvent(ANALYTIC_EVENT_NAME, data);
}

export function logAnalyticMozartDialog(params: LogDialogParams) {
  const data: LogEventDefectAlert = {
    PARTNER_ID: params.partnerId,
    STORE_ID: params.storeId,
    ACTION: params.action,
  };
  amplitude.logEvent(ANALYTIC_EVENT_NAME, data);
}

export const mozartNotificationAnalytics = {
  logDefectAlert: logAnalyticMozartDefectAlert,
  logDialog: logAnalyticMozartDialog,
} as const;
